import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initMedicalPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: '', //입력데이터 sequence
  family_seqid: 0, //부양가족 sequence
  amt: 0, // 의료비(일반)
  htx_amt: 0, //의료비(국세청)
  expt_htx_pdf: 0, //국세청 PDF 제외금액
  data_type: '', //구분
  is_glass: 'N', //안경구입여부
  is_sf_practice: 'N', //난임시술비여부
  is_prem_baby: 'N', //선청성 미숙아 여부
  co_num: '', //사업자번호
  trade_nm: '', //상호
  cnt: 0, //건수
  is_htx_pdf: 'Y', //국세청 PDF 자료여부
  is_postpartum: 'N', //산후조리원비 여부
  is_ph_insu: 'N', //실손의료보험금 여부
};

/**
  신용카드
**/
export const medicalDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initMedicalPayload,
  payload: _.cloneDeep(initMedicalPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
